<template>
<div class="input__wrapper">
 <button class="addListItem innerBtn" @click="handleAddListItem">+ List Item</button>
       <div class="ListItem" v-for="(listItem, index) in list" :key="listItem.id">
            <PopOrderListItem :listItem="listItem" />
            <button class="modal__button" @click="handleInputChildDelete(index)">
            <i class="button__image">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
            </i>
    </button>
        </div>
 <DeleteButton :index="index" />
</div> 
</template>

<script setup>
import DeleteButton from '@/components/PopUp/DeleteButton.vue'
import { fieldFactory } from '@/helper/popFieldFactory';
import PopOrderListItem from '@/components/PopUp/PopOrderListItem.vue'
import { nanoid } from 'nanoid'
import { toRaw } from 'vue';
import { popStore } from '@/helper/popStore';
const props = defineProps({
    popStoreId:String,
    index:Number
})

const list = fieldFactory('list', props.popStoreId)

const handleAddListItem = () => {
    const id = nanoid(10)
    list.value = [...toRaw(list.value), {id}]
}

const handleInputChildDelete = (index) => {
    popStore.value[props.index].list.splice(index, 1)
}

</script>

<style>

</style>